// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"2ddebe27","563":"99e62569"}[chunkId] + ".chunk.js";
};